/**
 * ConnectionStatus Component
 * Shows WebSocket connection status
 */

import React from 'react';
import { Wifi, WifiOff, Loader2, AlertCircle } from 'lucide-react';
import { ConnectionState } from '../types';

interface ConnectionStatusProps {
  connectionState: ConnectionState;
  error: string | null;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  connectionState,
  error,
}) => {
  const { status, provider } = connectionState;

  if (status === 'connected') {
    return (
      <div className="flex items-center gap-2 text-xs text-green-600 dark:text-green-400">
        <Wifi className="h-4 w-4" />
        <span>Connected</span>
        {provider && (
          <span className="text-gray-500 dark:text-gray-400">({provider})</span>
        )}
      </div>
    );
  }

  if (status === 'connecting') {
    return (
      <div className="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>Connecting...</span>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex items-center gap-2 text-xs text-red-600 dark:text-red-400">
        <AlertCircle className="h-4 w-4" />
        <span>Connection error</span>
        {error && (
          <span className="text-gray-500 dark:text-gray-400" title={error}>
            ({error.substring(0, 20)}...)
          </span>
        )}
      </div>
    );
  }

  // disconnected
  return (
    <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
      <WifiOff className="h-4 w-4" />
      <span>Disconnected</span>
    </div>
  );
};
